// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".raH6a4kS{align-items:center;border:1px solid #32388c;border-radius:var(--border-radius);color:#32388c;display:flex;font-size:1rem;font-weight:500;justify-content:center;line-height:1.4;min-height:2.63rem;padding:.38rem .75rem;width:-moz-fit-content;width:fit-content}@media(hover:hover){.raH6a4kS:not(.luhgKFep):hover{background-color:rgba(50,56,140,.2)}}@media(hover:none){.raH6a4kS:not(.luhgKFep):active{background-color:rgba(50,56,140,.2)}}.raH6a4kS:not(.luhgKFep):active{transform:scale(.98)}.raH6a4kS>*+*{margin-left:.38rem}.luhgKFep{background-color:#32388c;color:#fff;cursor:default}.JXYSS3qK{--size:1.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"xl": "1920.98",
	"voteBtn": "raH6a4kS",
	"voteBtnActive": "luhgKFep",
	"voteBtnIcon": "JXYSS3qK"
};
module.exports = ___CSS_LOADER_EXPORT___;
